<template>
    <div class="free-charge tw-flex tw-flex-col tw-items-center type-client tw-px-4">
        <title-section
        title="¿La casa está libre de cargas?"></title-section>
    
        <div class="mdc-chip-set mdc-chip-set--choice justify-center tw-mt-8 tw-flex">
            <div class="mdc-chip" :class="{'mdc-chip--selected': isSelected(true)}" @click="selectChip(true)" role="row">
            <div class="mdc-chip__ripple"></div>
            <span role="gridcell">
                <span role="button" tabindex="0" class="mdc-chip__primary-action">
                <span class="mdc-chip__text tw">Si</span>
                </span>
            </span>
            <span role="gridcell">
                <i class="material-icons mdc-chip__icon" role="button">done</i>
            </span>
            </div>
            <div class="mdc-chip" :class="{'mdc-chip--selected': isSelected(false)}" @click="selectChip(false)" role="row">
            <div class="mdc-chip__ripple"></div>
            <span role="gridcell">
                <span role="button" tabindex="0" class="mdc-chip__primary-action">
                <span class="mdc-chip__text tw">No</span>
                </span>
            </span>
            <span role="gridcell">
                <i class="material-icons mdc-chip__icon" role="button">done</i>
            </span>
            </div>
        </div>
    </div>
    </template>
    
    <script>
    import { initiateChips } from "../../utils";
    import { mapMutations, mapGetters } from "vuex";
    export default {
    computed: {
        ...mapGetters({
            wizard: 'getWizard'
        })
    },
    methods: {
        ...mapMutations(["selectBurdened"]),
        selectChip(chip) {
        this.selectBurdened(Boolean(chip));
        this.$router.push({ name: "PersonalForm" });
        },
        isSelected(chip){
            return chip === this.wizard.typeApartment;
        }
    },
    mounted() {
        initiateChips();
    }
    };
    </script>
    
    <style lang="scss" scoped>
    .sale-status {
            .mdc-chip {
            width: 100% !important;
            justify-content: flex-start !important;
        }
    }
    </style>
      